import React from 'react';
import PropTypes from 'prop-types';

import Link from '@appComponents/Link';

const FormChangelogEntry = ({date, user, label}) => {
    const userName = user
        ? (<Link name='users.edit' newWindow={true} params={{id: user.id}}>{user.name}</Link>)
        : (<i>[unknown user]</i>);

    return (
        date ?
            (
                <div className='formRow'>
                    <div className='changelogData__row'>
                        {/* eslint-disable-next-line jsx-a11y/label-has-for */}
                        <label>{label}</label>
                        <span className='changelogData__info'>{date} by {userName}</span>
                    </div>
                </div>
            )
            : null
    );
};

FormChangelogEntry.propTypes = {
    date: PropTypes.string,
    user: PropTypes.object,
    label: PropTypes.string,
};

export default FormChangelogEntry;
